module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/artillery-strike-reward-100.c6c07f2c.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/artillery-strike-reward-100.png
// module id = 3776
// module chunks = 11